module.exports = __webpack_public_path__ + "img/quiz.8b382673.svg";